import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Extract up to 2 initials from a name (e.g. "John Doe" -> "JD") */
export function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map(s => s.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('')
}
